import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private history: string[] = [];
  private readonly EXCLUDED_PATTERNS = ['/error-page', '/error'];

  private router = inject(Router);

  /**
   * À appeler une seule fois au démarrage de l'application (dans app.config.ts)
   */
  init(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        const isExcluded = this.EXCLUDED_PATTERNS.some(pattern => url.includes(pattern));
        if (!isExcluded) {
          this.history.push(url);
          if (this.history.length > 10) {
            this.history.shift();
          }
        }
      });
  }

  /**
   * Retourne la dernière URL valide (hors pages d'erreur).
   * Retourne null si aucun historique valide n'existe.
   */
  getPreviousValidUrl(): string | null {
    if (this.history.length < 2) {
      return null;
    }
    return this.history[this.history.length - 2];
  }
}
